import { Platform } from 'react-native';
import { Prompt, ResponseType } from 'expo-auth-session';
import environment from '../environments';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AppManifest from '../common/AppManifest';

export type FitbitAuthProps = {
  clientId: string;
  redirectUri: string;
};

export const getFitbitAuthRequestConfig = (
  clientId: string,
  redirectUri: string
) => {
  return {
    responseType: ResponseType.Token,
    clientId,
    redirectUri,
    scopes: ['activity', 'sleep', 'weight', 'oxygen_saturation', 'heartrate'],
    extraParams: { expires_in: '2592000' },
    prompt: Prompt.Login
  };
};

export const fitbitDiscovery = {
  authorizationEndpoint: 'https://www.fitbit.com/oauth2/authorize',
  tokenEndpoint: 'https://api.fitbit.com/oauth2/token',
  revocationEndpoint: 'https://api.fitbit.com/oauth2/revoke'
};

export function getFitbitAuthProps(): FitbitAuthProps {
  if (Platform.OS === 'web') {
    return {
      clientId: environment.fitbitWebClientId,
      redirectUri: environment.oAuthRedirectWebUri
    };
  }
  return {
    clientId: environment.fitbitAppClientId,
    redirectUri: environment.oAuthRedirectAppUri
  };
}

export const getFitbitTokenExpiration = async () => {
  return await AsyncStorage.getItem('fitbitTokenExpiration');
};
